import { useTranslation } from '@fareye/common'
import { valueColor } from '@fareye/configs'
import { latLng, Marker, Popup, Span, useMap } from '@fareye/ui'
import { startCase } from '@fareye/utils'
import React from 'react'
import { displayTime } from '../../../utility/function'
import FieldValue from './FieldValue'

export function StopsMarker({
  data,
  icon,
  selected,
  apiData,
  indexNumber
}: any) {
  const {
    eta,
    ata,
    atd,
    std,
    sta,
    name,
    city,
    state,
    status,
    sequence,
    latitude,
    longitude,
    activityType
  } = data || {}
  const { t } = useTranslation()
  const { inState } = apiData
  let stopsData = apiData.nodes ? apiData.nodes : apiData.stops
  const completedFlag = inState === 'completed'
  let stopLen = stopsData.length
  let stops = [...stopsData.slice(1, stopLen - 1)]
  const originData = stopsData[0] || {}
  const destinationData = stopsData[stopLen - 1] || {}
  const nextStop = apiData?.nextStop || {}
  const nextStopIsDestination = destinationData?.nodeId === nextStop?.nodeId
  const nextStopIndex: any = nextStopIsDestination
  const [fakeState, setFakeState] = React.useState(0)
  const map = useMap()
  let ref = React.useRef(null)
  const hideETA =
    indexNumber <= nextStopIndex - 1 || nextStopIsDestination || completedFlag
  function openPopup(marker: any) {
    if (marker && selected) {
      marker.leafletElement.openPopup()
    }
    if (marker && !selected) {
      marker.leafletElement.closePopup()
    }
  }
  React.useEffect(() => {
    if (selected && ref) {
      map.openPopup(ref.current as any)
      setFakeState(fakeState + 1)
    }
  }, [selected])
  return (
    <Marker
      position={latLng(latitude, longitude)}
      icon={icon}
      // ref={el => openPopup(el)}
      eventHandlers={{
        click: () => setFakeState(fakeState + 1)
      }}
    >
      <Popup minWidth={149} ref={ref}>
        <Span variant="h5" style={{ marginBottom: 4 }}>
          {`S${sequence}: ${city || name}`}
        </Span>
        <Span variant="ellipsis secondary" style={{ marginBottom: 10 }}>
          {name}
        </Span>
        <Span
          color="rgba(24,144,255,1)"
          variant="ellipsis secondary"
          style={{ marginBottom: 10 }}
        >
          {t(startCase(activityType) || 'N/A')}
        </Span>
        <FieldValue
          style={{ marginBottom: 4 }}
          labelStyle={{
            color: valueColor,
            fontWeight: 500
          }}
          label={t('Route State')}
          value={t(state) || '-'}
        />
        <FieldValue
          style={{ marginBottom: 15 }}
          labelStyle={{ color: valueColor, fontWeight: 500 }}
          label={`${t('Status')}${':'} `}
          value={t(status) || '-'}
        />
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label={t('STA')}
          value={displayTime(sta)}
        />
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label={ata?.time || hideETA ? t('ATA') : t('ETA')}
          value={
            ata?.time ? displayTime(ata) : hideETA ? '-' : displayTime(eta)
          }
        />
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label={t('STD')}
          value={displayTime(std)}
        />
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label={t('ATD')}
          value={displayTime(atd)}
        />
      </Popup>
    </Marker>
  )
}
